var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('user-mail-history-table',{ref:"userMailHistoryTable",attrs:{"items":_vm.item.mailHistories,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }